import React from "react";

import Body from "../components/Body";

const Home = () => {
  return (
    <div>
      
      <Body />
      
    </div>
  );
};

export default Home;
